(function() {

	angular
		.module('ngmvac')
		.factory('ContentApiService', ContentApiService);

	ContentApiService.$inject = ['$http'];

	function ContentApiService($http) {

		var baseUrl = '/api/content';

		return {
			get: get,
			facilities: Facilities,
			images: Images,
			issues: Issues,
			getImages: getImages,
			getAllAccomodation: getAllAccomodation,
			getRoomFacilitiesFor: getRoomFacilitiesFor

		}

		function Facilities(hotelCode) {
			return $http.post(baseUrl + '/facilities', {params: {'hotelCode': hotelCode}});
		}

		function Images(hotelCode) {
			return $http.post(baseUrl + '/images', {params: {'hotelCode': hotelCode}});
		}


		function Issues(hotelCode) {
			return $http.post(baseUrl + '/issues', {params: {'hotelCode': hotelCode}});
		}

		function get(codes, fields) {
			if( fields === undefined ) {
				fields = ['all'];
			}
			return $http.post(baseUrl, {codes: codes, fields: fields});
		}

		function getImages(params){
			return $http.post('/hotel/getImages', params);
		}

		function getAllAccomodation() {
			return $http.get('/api/alojamiento');
		}

		function getRoomFacilitiesFor(rooms) {
			return $http.post('/rooms/facilities', {codes: rooms});
		}

	}

})();
